// src/components/NavigationBar.jsx

import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaHome, FaBars } from 'react-icons/fa';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust the path as necessary
import './NavigationBar.css';

function NavigationBar({ user }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Toggle the menu open/closed
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  // Close the menu when clicking outside or after selecting an item
  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Sign-out handler
  const handleSignOut = async () => {
    try {
      await signOut(auth);
      console.log('User signed out successfully.');
      navigate('/sign-in');
    } catch (error) {
      console.error('Error signing out:', error);
      // Optionally, display an error message to the user
    }
    closeMenu();
  };

  return (
    <nav className="navigation-bar">
      <div className="nav-container">
        {/* Home Button Icon */}
        <NavLink to="/" className="home-icon" aria-label="Home">
          <FaHome />
        </NavLink>

        {/* Dropdown Menu */}
        <div className="dropdown">
          <button
            className="menu-button"
            aria-label="Menu"
            onClick={toggleMenu}
          >
            <FaBars />
          </button>

          {menuOpen && (
            <ul className="dropdown-menu" onMouseLeave={closeMenu}>
              {user ? (
                <>
                  <li>
                    <NavLink
                      to={`/companies/${user.companyId}`}
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      onClick={closeMenu}
                    >
                      Company Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/create-site"
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      onClick={closeMenu}
                    >
                      Create a Site
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/site-dashboard"
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      onClick={closeMenu}
                    >
                      All Sites
                    </NavLink>
                  </li>
                  <li>
                    <button
                      onClick={handleSignOut}
                      aria-label="Sign Out"
                      className="sign-out-button"
                    >
                      Sign Out
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <NavLink
                      to="/sign-in"
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      onClick={closeMenu}
                    >
                      Sign In
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/create-account"
                      className={({ isActive }) => (isActive ? 'active' : '')}
                      onClick={closeMenu}
                    >
                      Create Account
                    </NavLink>
                  </li>
                </>
              )}

              {/* Always-visible links */}
              <li>
                <NavLink
                  to="/privacy-policy"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                  onClick={closeMenu}
                >
                  Privacy Policy
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) => (isActive ? 'active' : '')}
                  onClick={closeMenu}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavigationBar;
